import './preload'

import { render } from 'solid-js/web'
import App from './app'
import { create_server_data_context, ServerDataProvider } from 'store/server'
import { Component } from 'solid-js'

const ctx = create_server_data_context()
for (const [k, v] of Object.entries(window.__SSR_DATA__ || {})) {
    ctx.set(k, v)
}

const Root: Component<{ page_loading?: boolean }> = P => {
    return (
        <ServerDataProvider context={ctx}>
            <App page_loading={P.page_loading} />
        </ServerDataProvider>
    )
}

let root = document.getElementById('root')
if (!root) {
    root = document.createElement('div')
    root.id = 'root'
    document.body.appendChild(root)
}
root.classList.add('root')

// if (RENDER_HASH != globalThis.__SSR_RENDER_HASH__) {
// console.log('wrong')
globalThis.__SSR_DATA__ = {}
root.innerHTML = ''
render(() => <Root page_loading />, root)
// } else if (root.children.length == 0) {
//     root.innerHTML = ''
//     render(() => <Root page_loading />, root)
// } else {
//     console.log('hydrating')
//     hydrate(() => <Root />, root)
// }
